<template>
  <transition name="bottom-slide">
    <div class="text-wrapper">
      <m-textArea class="content-main">
        <div class="content-title">
          <h3>{{content.name || content.title}}</h3>
        </div>
        <div class="content-img" v-if="content.out_link">
          <img :src="content.out_link | pics">
        </div>
        <ul class="content-list" v-if="headers">
          <template v-for="(item, index) in headers">
            <li
              v-if="content[item.tag]"
              :key="index"
            >
              <h4>{{item.name}}:</h4>
              <span v-if="item.tag === 'description'" v-html="content[item.tag]"></span>
              <span v-else>{{content[item.tag]}}</span>
            </li>
          </template>
        </ul>
      </m-textArea>
      <Arrow class="btn-arrow" type="back" @arrowClick="$emit('close')"></Arrow>
    </div>
  </transition>
</template>

<script>
import TextArea from "@/components/TextArea";
import Arrow from "@/components/Arrow.vue";

export default {
  props: {
    content: Object,
    headers: Array
  },
  components: {
    "m-textArea": TextArea,
    Arrow
  },
  filters: {
    pics: function(url) {
      const host = location.hostname === "shadow.caa.edu.cn"
        ? ""
        : "http://shadow.caa.edu.cn";
      return host + "/pyold/literature/" + url;
    }
  },
};
</script>

<style lang="scss">
@import "../../assets/base";
.text-wrapper {
  @include pageset;
  z-index: 20;
  background-image: url("~@/assets/img/bg.jpg");
  background-position: bottom center;
  background-size: auto 100%;
  .btn-arrow {
    position: absolute;
    bottom: 1rem;
    margin-left: 1.2rem;
  }
}

.content-main {
  height: 80vh;

  .text-main {
    padding-right: 1rem;
  }

  .content-title {
    padding-top: 2rem;
    margin-bottom: 1rem;

    @include title-h3(1.125rem);
    h3 {
      margin: 0;
      height: 1.2rem;
      line-height: 1.2;

      &::before,
      &::after {
        height: 1.2rem;
      }

      &::before {
        background-image: url("~@/assets/img/video/title-left.png");
      }

      &::after {
        background-image: url("~@/assets/img/video/title-right.png");
      }
    }
  }

  .content-img {
    margin-bottom: 1em;

    img {
      display: block;
      max-height: 50vh;
      max-width: 100%;
    }
  }

  .content-list {
    margin: 0;
    font-size: 0.875rem;
    line-height: 1.8;

    li {
      white-space: nowrap;

      &::before {
        content: "";
        position: relative;
        display: inline-block;
        width: 5px;
        height: 5px;
        top: -2px;
        margin-right: 0.5rem;
        background-color: $primary;
        vertical-align: middle;
      }
      h4 {
        display: inline-block;
        margin: 0;
        margin-right: 0.5rem;
        font-weight: 500;
      }
      span {
        white-space: normal;
      }
    }
  }
}
</style>
